import { Controller } from "@hotwired/stimulus"
import { turboFetch } from "../helpers/html_fetch"

export default class extends Controller {
  static values = {
    requestFormat: String,
    authenticateUrl: String,
  }

  static targets = [
    "icon",
    "button",
    "counterText",
  ]

  async submit(e) {
    e.preventDefault()

    const url = this.buttonTarget.dataset.likeUrl
    const liked = this.buttonTarget.dataset.likeLiked == "true"

    this.#disable()
    try {
      await turboFetch(url, { method: liked ? "DELETE" : "POST" })
    } catch (error) {
      if (error.status == 401) {
        window.Turbo.visit(this.authenticateUrlValue)
      } else {
        console.error(error)
      }
    } finally {
      this.#enable()
    }
  }

  #disable() {
    if (this.hasCounterTarget) this.counterTarget.disabled = true
    this.buttonTarget.disabled = true
    this.iconTarget.classList.remove("a-pulse-grow")
    this.iconTarget.classList.add("a--with-delay")
    this.iconTarget.classList.add("a-spin--on")
  }

  #enable() {
    if (this.hasCounterTarget) this.counterTarget.disabled = false
    this.buttonTarget.disabled = false
    this.iconTarget.classList.remove("a--with-delay")
    this.iconTarget.classList.remove("a-spin--on")
    this.iconTarget.classList.add("a-pulse-grow")
  }
}
